module.exports = __webpack_public_path__ + "static/media/donaronlineLogo.2fd2ad01.svg";